"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for management groups API calls.
 */
var GroupMixin = /** @class */ (function () {
    function GroupMixin() {
    }
    /**
     * Get groups a client belongs to in an agency
     * @param agencyId
     * @param clientId
     * @param type
     * @param limit
     * @param page
     * @param search
     * @param callback
     */
    GroupMixin.prototype.getClientGroups = function (agencyId, clientId, type, limit, page, search, callback) {
        var _this = this;
        var urlParams = {};
        if (type != null) {
            urlParams['type'] = models_1.AgencyGroupTypeEnum[type];
        }
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'groups', models_1.parseClientGroup); }));
        };
        this.http.get("/agencies/" + agencyId + "/clients/" + clientId + "/groups", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Retrieve a client's group memberships w/ pagination
     * @param agencyId
     * @param clientId
     * @param groupType
     * @param membershipFilter
     * @param limit
     * @param page
     * @param sortConfig
     * @param search
     * @param callback
     */
    GroupMixin.prototype.getGroupMembershipsForClient = function (agencyId, clientId, groupType, membershipFilter, limit, page, sortConfig, search, callback) {
        var _this = this;
        var urlParams = {
            clientId: clientId,
            membershipFilter: models_1.MembershipStatusFilterEnum[membershipFilter],
            limit: limit,
            page: page,
            order: sortConfig.direction,
        };
        if (groupType != null) {
            urlParams.groupType = models_1.AgencyGroupTypeEnum[groupType];
        }
        if (search != null) {
            urlParams.search = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'groups', models_1.GroupMembershipStatus.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/groups/membership-status", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Update a client's membership to a group in an agency
     * @param agencyId
     * @param groupId
     * @param clientId
     * @param canSend
     * @param canRespond
     * @param responseOptionIds
     * @param callback
     */
    GroupMixin.prototype.updateClientGroupMembership = function (agencyId, groupId, clientId, canSend, canRespond, responseOptionIds, callback) {
        var _this = this;
        var body = {};
        if (canSend != null || canRespond != null) {
            body.permissions = {};
            if (canSend != null) {
                body.permissions.canSend = canSend;
            }
            if (canRespond != null) {
                body.permissions.canRespond = canRespond;
            }
        }
        if (responseOptionIds != null) {
            body.responseOptions = responseOptionIds;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/groups/" + groupId + "/clients/" + clientId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get groups in an agency by ID
     * @param agencyId
     * @param type
     * @param limit
     * @param page
     * @param sortConfig
     * @param search
     * @param callback
     */
    GroupMixin.prototype.getAgencyGroups = function (agencyId, type, limit, page, sortConfig, search, callback) {
        var _this = this;
        var urlParams = {
            order: sortConfig.direction,
        };
        if (type != null) {
            urlParams['type'] = models_1.AgencyGroupTypeEnum[type];
        }
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'groups', models_1.AgencyGroup.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/groups", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get groups of a certain type for an agency
     * @param agencyId
     * @param type
     * @param callback
     */
    GroupMixin.prototype.getAllGroupsByType = function (agencyId, type, callback) {
        var _this = this;
        var urlParams = {};
        if (type != null) {
            urlParams['type'] = models_1.AgencyGroupTypeEnum[type];
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.BasicAgencyGroup.parse, 'warn'));
        };
        this.http.get("/agencies/" + agencyId + "/groups/all", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get units in an agency
     * @param agencyId
     * @param callback
     */
    GroupMixin.prototype.getAllUnits = function (agencyId, callback) {
        var _this = this;
        var urlParams = {};
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.RequestUnit.parse, 'warn'));
        };
        this.http.get("/agencies/" + agencyId + "/units/all", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get members of a specific group w/ pagination
     * @param agencyId
     * @param groupId
     * @param membershipFilter
     * @param limit
     * @param page
     * @param search
     * @param sortConfig
     * @param callback
     */
    GroupMixin.prototype.getGroupMembers = function (agencyId, groupId, membershipFilter, limit, page, search, sortConfig, callback) {
        var _this = this;
        var urlParams = {
            groupId: groupId,
            membershipFilter: models_1.MembershipStatusFilterEnum[membershipFilter],
            order: sortConfig.direction,
        };
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'clients', models_1.MembershipStatus.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/clients/membership-status", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add a client to a dispatch group
     * @param agencyId
     * @param groupId
     * @param clientId
     * @param responseOptions
     * @param canSend
     * @param canRespond
     * @param callback
     */
    GroupMixin.prototype.addClientToDispatchGroup = function (agencyId, groupId, clientId, responseOptions, canSend, canRespond, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
            responseOptions: responseOptions.map(function (r) { return r.id; }),
            permissions: {
                canSend: canSend,
                canRespond: canRespond,
            },
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/groups/" + groupId + "/clients", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add a client to a messaging group
     * @param agencyId
     * @param groupId
     * @param clientId
     * @param canSend
     * @param callback
     */
    GroupMixin.prototype.addClientToMessagingGroup = function (agencyId, groupId, clientId, canSend, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
            permissions: {
                canSend: canSend,
            },
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/groups/" + groupId + "/clients", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add all clients in an agency to a dispatch group
     * @param agencyId
     * @param groupId
     * @param responseOptions
     * @param canSend
     * @param canRespond
     * @param callback
     */
    GroupMixin.prototype.addAllClientsToDispatchGroup = function (agencyId, groupId, responseOptions, canSend, canRespond, callback) {
        var _this = this;
        var body = {
            responseOptions: responseOptions.map(function (r) { return r.id; }),
            permissions: {
                canSend: canSend,
                canRespond: canRespond,
            },
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/groups/" + groupId + "/clients/all", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add all clients in an agency to a messaging group
     * @param agencyId
     * @param groupId
     * @param canSend
     * @param callback
     */
    GroupMixin.prototype.addAllClientsToMessagingGroup = function (agencyId, groupId, canSend, callback) {
        var _this = this;
        var body = {
            permissions: {
                canSend: canSend,
            },
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/groups/" + groupId + "/clients/all", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove a client from a group in an agency
     * @param agencyId
     * @param groupId
     * @param clientId
     * @param callback
     */
    GroupMixin.prototype.removeClientFromGroup = function (agencyId, groupId, clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/groups/" + groupId + "/clients/" + clientId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove all clients from a group in an agency
     * @param agencyId
     * @param groupId
     * @param callback
     */
    GroupMixin.prototype.removeAllClientsFromGroup = function (agencyId, groupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/groups/" + groupId + "/clients/all", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a messaging group by ID
     * @param agencyId
     * @param groupId
     * @param callback
     */
    GroupMixin.prototype.deleteMessagingGroup = function (agencyId, groupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/groups/" + groupId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a group's name by ID
     * @param agencyId
     * @param groupId
     * @param newGroupName
     * @param callback
     */
    GroupMixin.prototype.editGroupName = function (agencyId, groupId, newGroupName, callback) {
        var _this = this;
        var body = {
            name: newGroupName,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/groups/" + groupId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a messaging group
     * @param agencyId
     * @param groupName
     * @param callback
     */
    GroupMixin.prototype.createMessagingGroup = function (agencyId, groupName, callback) {
        var _this = this;
        var body = {
            name: groupName,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyGroup.parse));
        };
        this.http.post("/agencies/" + agencyId + "/groups", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a group alert override
     * @param agencyId
     * @param groupId
     * @param groupAlertOverride
     * @param callback
     */
    GroupMixin.prototype.createGroupAlertOverride = function (agencyId, groupId, groupAlertOverride, callback) {
        var _this = this;
        var body = {
            description: groupAlertOverride.description,
            type: groupAlertOverride.type,
            value: groupAlertOverride.value,
            alert: groupAlertOverride.alert,
            priority: groupAlertOverride.priority,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/groups/" + groupId + "/overrides", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a group alert override
     * @param agencyId
     * @param groupId
     * @param groupAlertOverride
     * @param callback
     */
    GroupMixin.prototype.editGroupAlertOverride = function (agencyId, groupId, groupAlertOverride, callback) {
        var _this = this;
        var body = {
            description: groupAlertOverride.description,
            type: groupAlertOverride.type,
            value: groupAlertOverride.value,
            alert: groupAlertOverride.alert,
            priority: groupAlertOverride.priority,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/groups/" + groupId + "/overrides/" + groupAlertOverride.id, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a group alert override
     * @param agencyId
     * @param groupId
     * @param groupAlertOverride
     * @param callback
     */
    GroupMixin.prototype.deleteGroupAlertOverride = function (agencyId, groupId, overrideId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/groups/" + groupId + "/overrides/" + overrideId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return GroupMixin;
}());
exports.default = GroupMixin;
//# sourceMappingURL=GroupMixin.js.map